/* eslint-disable indent */
import $ from './jquery-global';

import { initMasonry } from './masonry.init.js'
import { initForm } from './form.init.js'

$.ajaxSetup({ global: true });

let ajaxUtilsSettings = { 
	enableAutoBrowserHistoryUpdate: false,
	scrollToTopOfTargetContainer: true,
	// used mainly to compensate for fixed-position page headers that are not properly handled by the current scrollTop implementation
	scrollTopDelta: -200
};

export function useAjaxAutoBrowserHistoryUpdate() {
	ajaxUtilsSettings.enableAutoBrowserHistoryUpdate = true;

	// initial state
	window.history.replaceState({ url: window.location.href }, null, window.location.href);

	$(document).ajaxSuccess(function (e1, xhr, options, data) {
		if (!ajaxUtilsSettings.enableAutoBrowserHistoryUpdate || (options.context && options.context.noHistoryUpdate)) return;
		if (options.type === 'GET') {
			var url = options.url;
			window.history.pushState({ url: url }, null, url);
		}
	});

	$(window).on('popstate', function (e1) {
		if (!ajaxUtilsSettings.enableAutoBrowserHistoryUpdate) return;
		if (e1.originalEvent.state && e1.originalEvent.state) {
			window.location.assign(e1.originalEvent.state.url);
		}
		else {
			console.log('History state not available');
		}
	});
}

$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
	$('.global-error h3.error-code').text(jqxhr.status);
	$('.global-error span.error-message').text(jqxhr.statusText);
	$('html,body').animate({ scrollTop: 0 }, 500);
	$('.global-error').fadeIn(200);
});

export const setupAjaxUtils = (container) => {
	container = container ? container : $(document);
	setObservers(container);
	var fullRefreshAfterResponse = false;
	var fullRefreshLocation = null;

	function getAjaxParam(item, key) {
		return $(item).data(key) || $(item).closest('.ajax-link,.ajax-form').data(key);
	}
	//function pushUrl(source, url) {
	//	if (!ajaxUtilsSettings.disableBrowserHistoryUpdate && window.history && !getAjaxParam(source, 'ajax-no-url-update')) {
	//		window.history.pushState({ url: url }, null, url);
	//	}
	//	return url;
	//}

	$('.auto-submit', container).change(function (e) {
		var form = $(e.currentTarget).closest('form');
		var targetButton = $(e.currentTarget).data("auto-submit-target");
		if (targetButton) $(targetButton, form).click();
		else form.submit();
	});

	$('.ajax-full-refresh', container).click(function (e) {
		fullRefreshAfterResponse = true;
		fullRefreshLocation = $(e.currentTarget).data('ajax-full-refresh-location');
	});

	function getUpdateMethod(selector) {
		var $selector = $(selector);
		var updateMode = $selector.data('ajax-update-mode');
		var targetContainer = $selector.parent();
		var targetIndex = $selector.index();
		switch (updateMode) {
		case "replace-content":
			return function (targetSelector, data) {
				if (checkFullRedirectDirective(data)) return;
				$(targetSelector).html(data);
				var newTarget = $(targetSelector);
				if (newTarget) {
					setupAjaxUtils(newTarget);
					checkFullRedirectDataAttribute(newTarget);
					checkFullRefresh(newTarget);
				}
			};
		case "append-content":
			return function (targetSelector, data) {
				if (checkFullRedirectDirective(data)) return;
				var responseSelector = $(targetSelector).data("response-selector");
				var realTarget = $(targetSelector).data("inner-target") ?
					$($(targetSelector).data("inner-target"), targetSelector) : $(targetSelector);
				if (responseSelector) {
					realTarget.append($(data).find(responseSelector));
				} else {
					realTarget.append(data);
				}

				var newTarget = $(targetSelector);
				if (newTarget) {
					setupAjaxUtils(newTarget);
					checkFullRedirectDataAttribute(newTarget);
					checkFullRefresh(newTarget);
				}

				//$('.article-list-container', realTarget).not(':first').remove();
			};

		case "replace-with":
		default:
			return function (targetSelector, data) {
				if (checkFullRedirectDirective(data)) return;
				$(targetSelector).replaceWith(data);
				var context = targetContainer.children(targetIndex).addBack();
				setupAjaxUtils(context);
				checkFullRedirectDataAttribute(context);
				checkFullRefresh(context);
			};
		}

		function checkFullRedirectDirective(data) {
			if (!data) return false;
			var directiveName = '::ajax:full-redirect:';
			data = (data + '').trimLeft();
			if (data.startsWith(directiveName)) {
				var url = data.substr(directiveName.length);
				return redirectIfNotNull(url);
			}
			return false;
		}
		function checkFullRedirectDataAttribute(context) {
			var url = $('.ajax-full-redirect', context).data('ajax-full-redirect-url');
			return redirectIfNotNull(url);
		}
		function redirectIfNotNull(url) {
			if (url) {
				document.location.assign(url);
				return true;
			}
			return false;
		}
		function checkFullRefresh(context) {
			var frQuery = $(".ajax-full-refresh", context);
			if (frQuery.length > 0) {
				fullRefreshLocation = frQuery.data('ajax-full-refresh-location');
				fullRefreshAfterResponse = true;
			}
			if (fullRefreshAfterResponse) {
				if (fullRefreshLocation) location.assign(fullRefreshLocation);
				else location.reload();
			}
		}
	}

	$('a.ajax-link, .ajax-link a', container).each(function (index, link) {

		function getParam(key) {
			return getAjaxParam(link, key);
			//return $(link).data(key) || $(link).closest('.ajax-link').data(key);
		}

		var target = getParam('ajax-target');
		var fullRefreshAfterResponse = getParam('ajax-full-refresh');
		var related = getParam('ajax-refresh-related');
		var httpMethod = getParam('ajax-method');
		if (httpMethod) httpMethod = (httpMethod + "").toUpperCase();
		if (!httpMethod) httpMethod = 'GET';
		var updateMethod = getUpdateMethod(target);
		var noAutoScrollTop = getParam('ajax-no-autoscroll');
		var noHistoryUpdate = getParam('ajax-no-history-update');
		var href = $(link).attr('href');
		if (!href || (!target && httpMethod === 'GET')) return;

		$(link).click(function (ev) {
			var $this = $(this);
			if ($this.hasClass("status-busy")) return;
			function getFormData() {
				var $link = $(link);
				var data = $("input", $link).serialize();
				var relatedInputs = $link.data('ajax-related-inputs');
				if (relatedInputs) {
					var extraData = $("input", $(relatedInputs)).serialize();
					if (!data) return extraData;
					if (extraData) return data + '&' + extraData;
				}
				return data;
			}

			ev.preventDefault();
			$this.addClass("status-busy");
			var offsetTop = target && $(target).offset().top;
			if (!noAutoScrollTop) scrollTop(offsetTop);
			$.ajax({
				url: href,
				method: httpMethod,
				//data: httpMethod === 'POST' ? getFormData() : null,
				data: getFormData(),
				context: { noHistoryUpdate: noHistoryUpdate },
				success: function (data) {
					if (fullRefreshAfterResponse) location.reload();
					updateMethod(target, data);
					if (related) refreshPanel(related);
					$this.removeClass("status-busy");
				}
			});
		});

	});

	function scrollTop(position) {
		if (ajaxUtilsSettings.scrollToTopOfTargetContainer) {
			position += ajaxUtilsSettings.scrollTopDelta;
			if (position < 0) position = 0;
		}
		else position = 0;
		$('html,body').animate({ scrollTop: position }, 500);

	}

	$('.ajax-form', container).each(function (index, form) {
		var target = $(form).data('ajax-target');
		var related = $(form).data('ajax-refresh-related');
		var refreshIfEmpty = $(form).data('ajax-refresh-if-empty');
		var noAutoScrollTop = $(form).data('ajax-no-autoscroll');
		var noHistoryUpdate = $(form).data('ajax-no-history-update');

		target = target ? $(target) : $(form);
		var updateMethod = getUpdateMethod(target);
		var offsetTop = target.length ? target.offset().top : 0;

		$(form).ajaxForm({
			//target: target,
			//replaceTarget: true,
			context: { noHistoryUpdate: noHistoryUpdate },
			//type: 'post',
			error: function () {
				fullRefreshAfterResponse = false;
			},
			success: function (data) {
				updateMethod(target, data);
				if (related && (!refreshIfEmpty || data == '')) refreshPanel(related);
				if (!noAutoScrollTop) scrollTop(offsetTop);
			},
			beforeSubmit: function (formData, jqForm, options) {
				$(".loader-overlay"/*, $(form)*/).show();
				return true;
			}
		});
	});

	function refreshPanel(selector) {
		$(selector).each(function (index, panel) {
			var $panel = $(panel);
			var updateMethod = getUpdateMethod($panel);
			var noHistoryUpdate = $panel.data('ajax-no-history-update');
			//var targetContainer = $panel.parent();
			//var targetIndex = $panel.index();

			var refreshUrl = $panel.data('ajax-refresh-action');
			$.ajax({
				// il metodo deve essere GET
				method: 'GET',
				url: refreshUrl,
				context: { noHistoryUpdate: noHistoryUpdate }
			}).done(function (data) {
				updateMethod(panel, data);
				//$panel.replaceWith(data);
				//ajaxUtils(targetContainer.children(targetIndex).addBack());
				//ytThumbs(); // get youtube thumb images
			});
		});
	}
}

function setObservers(container) { // richiamato da ajaxUtils()
	container = container ? container : $(document);
	if (typeof initMasonry != "undefined") initMasonry();
	initForm(container);
	//if (typeof initForm != "undefined") initForm();
}

function isElementInViewport(el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	if (typeof el === "undefined") {
		return false;
	}

	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= ((window.innerHeight - 50) || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}